<ion-app>
  <!-- Header benötigt eigenen Component-->
  <ion-split-pane contentId="main-content" [disabled]="isEdge()">
    <ion-menu contentId="main-content">
      <ion-header mode="ios">
        <ion-toolbar>
          <ion-title>Menü</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <!-- Für die gesamte Liste sollte ein component erstellt werden.-->
        <ion-list>
          <ion-menu-toggle auto-hide="false">
            <ng-container
              *ngIf="
                data.loggedIn &&
                (data.loginResponse.shops.length > 0 ||
                  data.loginResponse.topartikelListe.length > 0)
              "
            >
              <ng-container *ngIf="imageUrl !== null && imageUrl !== ''">
                <ion-item-divider>Bild</ion-item-divider>
                <ion-img [src]="imageUrl"></ion-img>
              </ng-container>
              <ion-item-divider>Shop</ion-item-divider>
              <ion-item
                button="true"
                [routerDirection]="'root'"
                routerLink="/home"
                (click)="this.resetImageUrl()"
              >
                <ion-icon slot="start" name="home"></ion-icon>
                <ion-label>Start</ion-label>
              </ion-item>
              <ng-container *ngFor="let p of data.loginResponse.shops">
                <ion-item
                  button="true"
                  [routerDirection]="'root'"
                  routerLink="/shop/{{ p.nr }}"
                  (click)="this.resetImageUrl()"
                  (click)="data.displayAgbBoolean(p.nr)"
                >
                  <ion-icon slot="start" name="cart"></ion-icon>
                  <ion-label> {{ p.name }} </ion-label>
                </ion-item>
              </ng-container>
              <ion-item
                button="true"
                [routerLink]="'bestellungen'"
                routerLink="/bestellungen"
                *ngIf="
                  config.historie &&
                  !data.loginResponse.isInfoIntern &&
                  !data.loginResponse.isInfoExtern
                "
              >
                <ion-icon slot="start" name="arrow-undo"></ion-icon>
                <ion-label>Bestellungen</ion-label>
              </ion-item>
              <ng-container *ngIf="kontakt !== null && kontakt !== ''">
                <ion-item-divider>Kontakt</ion-item-divider>
                <ion-item>
                  <ion-label class="ion-text-wrap">
                    <div [innerHTML]="kontakt"></div>
                    <div *ngIf="data.showAGB">
                      <span
                        >AGB:
                        <a target="_blank" href="{{ data.shopAGBLink }}"> als PDF ansehen </a>
                      </span>
                    </div>
                  </ion-label>
                </ion-item>
              </ng-container>
            </ng-container>
            <ng-container
              *ngIf="
                data.loggedIn &&
                !(
                  data.loginResponse.shops.length > 1 ||
                  data.loginResponse.topartikelListe.length > 0
                )
              "
            >
              <ion-item
                button="true"
                [routerDirection]="'root'"
                routerLink="/shop/{{ data.loginResponse.shops[0].nr }}"
                *ngIf="router.url !== '/shop/' + data.loginResponse.shops[0].nr"
              >
                <ion-icon slot="start" name="cart"></ion-icon>
                <ion-label>Zurück</ion-label>
              </ion-item>
              <ion-item
                button="true"
                [routerLink]="'bestellungen'"
                routerLink="/bestellungen"
                *ngIf="
                  config.historie &&
                  !data.loginResponse.isInfoIntern &&
                  !data.loginResponse.isInfoExtern
                "
              >
                <ion-icon slot="start" name="arrow-undo"></ion-icon>
                <ion-label>Bestellungen</ion-label>
              </ion-item>
              <ion-item-divider>Kontakt</ion-item-divider>
              <ion-item>
                <ion-label class="ion-text-wrap" [innerHTML]="data.loginResponse.shops[0].kontakt">
                  <br />
                </ion-label>
              </ion-item>
            </ng-container>
            <ion-item-divider *ngIf="data.loggedIn"
              >Benutzer: {{ data.loginResponse.name }}</ion-item-divider
            >
            <ion-item-divider *ngIf="!data.loggedIn">Benutzer</ion-item-divider>
            <ion-item
              button="true"
              [routerDirection]="'root'"
              [routerLink]="'/login'"
              (click)="logout()"
            >
              <ion-icon slot="start" name="log-in" *ngIf="!data.loggedIn"></ion-icon>
              <ion-icon slot="start" name="log-out" *ngIf="data.loggedIn"></ion-icon>
              <ion-label> A{{ data.loggedIn ? "b" : "n" }}melden </ion-label>
            </ion-item>
            <ion-item
              button="true"
              [routerDirection]="'root'"
              *ngIf="
                data.loggedIn &&
                !data.loginResponse.isInfoIntern &&
                !data.loginResponse.isInfoExtern
              "
              [routerLink]="'/ChangePassword'"
            >
              <ion-icon slot="start" name="person-circle"></ion-icon>
              <ion-label> Passwort ändern </ion-label>
            </ion-item>
            <ion-item-divider>Allgemein</ion-item-divider>
            <ion-item button="true" [routerDirection]="'root'" [routerLink]="'/impressum'">
              <ion-icon slot="start" name="list"></ion-icon>
              <ion-label> Impressum & Datenschutz </ion-label>
            </ion-item>
            <ion-item button="true" (click)="install()" *ngIf="data.installPrompt">
              <ion-icon slot="start" name="cube"></ion-icon>
              <ion-label> Auf Startbildschirm bringen </ion-label>
            </ion-item>
            <ion-item button="true" (click)="installIOs()" *ngIf="showInstallMessage">
              <ion-icon slot="start" name="cube"></ion-icon>
              <ion-label> Auf Startbildschirm bringen </ion-label>
            </ion-item>
            <ng-container *ngIf="data.loggedIn && data.loginResponse.links.length > 0">
              <ion-item-divider>Weitere Informationen</ion-item-divider>
              <ion-item
                button="true"
                *ngFor="let p of data.loginResponse.links"
                (click)="followLink(p.url)"
              >
                <ion-icon slot="start" [name]="p.icon"></ion-icon>
                <ion-label class="ion-text-wrap">
                  {{ p.text }}
                </ion-label>
              </ion-item>
            </ng-container>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>

      <!-- Footer benötigt eigenen component -->
      <ion-footer>
        <div style="font-size: 11px; padding-left: 20px">V.:{{ version.version }}</div>
      </ion-footer>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
